import { useSelector, useDispatch } from "react-redux";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const AwardList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [awardListData, setAwardListData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [apiStatus, SetApiStatus] = useState(undefined);
  useEffect(() => {
    dispatch(updateNavbarHeading("Award"));
  }, []);
  const columns = {
    EmployeeName: { text: "Employee", width: "60px", align: "start", visible: true },
    Name: { text: "Title", align: "start", width: "100px", visible: true },
    Remarks: { text: "Remarks", width: "100px", align: "start", visible: true },
    Score: { text: "Score", align: "end", width: "20px", visible: true },
    CreatedDate: { text: "Awarded on", width: "40px", align: "center", visible: true },
  };

  useEffect(() => {
    fetchGetData();
  }, []);

  const fetchGetData = async () => {
    try {
      let response;
      response = await GetServiceCaller(`${API_URL}awards`);

      if (response?.status === 200) {
        SetApiStatus(response?.status);
        setAwardListData(response?.data?.data?.map(o => ({ ...o, canDelete: 0, canEdit: 0 })).reverse());
      }
    } catch (error) {
      console.error("Fetching Error ", error);
    }
  };

  const handleEdit = (id) => {
    navigate(`/awards/edit/${id.ID}`);
  };

  const handleDelete = (id) => { };

  const handleAddNewPage = () => {
    navigate("/awards/add");
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className=" rounded bg-white" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={awardListData}
              columns={columns}
              itemsPerPage={10}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isSorting={true}
              showIcon1={true}
              showIcon2={true}
              isActionRequired={true}
              isAddNewBtnRequired={true}
              showIcon3={false}
              showIcon4={false}
              showIcon5={false}
              handleIcon1={handleEdit}
              handleAddNew={handleAddNewPage}
              // handleIcon3={handleDelete}
              handleIcon2={handleDelete}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon1Text: " Edit",
                Icon1Flag: ["canEdit"],
                Icon2: <i class="bi bi-trash-fill icons"></i>,
                Icon2Text: "Delete",
                Icon2Flag: "canDelete",
                Icon3: <i class="bi bi-eye-fill icons"></i>,
                Icon4: <i class="bi bi-plus-square icons"></i>,
                Icon4Text: " Add Sub-Contractor",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AwardList;
